import request from '@/utils/request'
import { getToken } from '@/utils/auth'

// chargerReportIndex页
// 上传
export function upload(params, zoon) {
  var formData = new FormData()
  formData.append('file', params.raw)
  formData.append('zone', zoon)
  return request({
    url: '/v3/manager/chargerMsg/upload',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data: formData
  })
}
// 获取列表数据
export function chargerSimpleList(params) {
  return request({
    url: '/v3/manager/chargerMsg/simple/list',
    method: 'post',
    data: params
  })
}
// chargerReportDetail页
// 某一台设备详情列表
export function chargerDetailList(params) {
  return request({
    url: '/v3/manager/chargerMsg/detail/list',
    method: 'post',
    data: params
  })
}
// 下载
export function downLoadExcel(params) {
  var d1 = 0
  var d2 = 0
  if (params.value5) {
    d1 = params.value5[0].getTime()
    d2 = params.value5[1].getTime()
  }
  var search = ''
  if (params.curveNo) {
    search = params.curveNo
  }
  var url = process.env.VUE_APP_BASE_API + '/v3/manager/chargerMsg/downLoad?token=' + getToken() + '&d1=' + d1 + '&d2=' + d2 + '&search=' + search + '&sn=' + params.sn + '&tem=' + params.tem
  console.log('url', url)
  window.open(url, '_bank')
}
// charges页
// 获取列表
export function pageList(params) {
  return request({
    url: '/v3/manager/charger/pageList',
    method: 'post',
    data: params
  })
}
// 上传excel
export function importExcel(params, zoon) {
  var formData = new FormData()
  formData.append('file', params.raw)
  formData.append('zone', zoon)
  return request({
    url: '/v3/manager/charger/import',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data: formData
  })
}
// 编辑弹窗--提交
export function updateDeviceQrData(params) {
  return request({
    url: '/v3/manager/charger/updateDeviceQrData',
    method: 'post',
    data: params
  })
}
// 绑定弹窗--提交
export function bindCharger(params) {
  return request({
    url: '/v3/manager/charger/bindCharger',
    method: 'post',
    data: params
  })
}
// models页
export function getList(params) {
  return request({
    url: '/v3/manager/module/list',
    method: 'post',
    data: params
  })
}
// 编辑--提交
export function update(params) {
  return request({
    url: '/v3/manager/module/update',
    method: 'post',
    data: params
  })
}
// 新增
export function add(params) {
  return request({
    url: '/v3/manager/module/add',
    method: 'post',
    data: params
  })
}
// 删除
export function moduleDelete(params) {
  return request({
    url: '/v3/manager/module/delete',
    method: 'post',
    data: params
  })
}
// bp列表
export function pageBpQrData(params) {
  return request({
    url: '/v3/manager/bp/pageBpQrData',
    method: 'post',
    data: params
  })
}
